import styled from 'styled-components';
import QUERIES from '../../theming/styles';

export const LogoSvg = styled.svg`

    * {
        fill: white;
        stroke: white;
    }

`;
